var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.VieraHtml5 = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.player.currentTime
  },

  /** Override to return current playrate */
  getPlayrate: function () {
    return null
  },

  /** Override to return Frames Per Secon (FPS) */
  getFramesPerSecond: function () {
    return null
  },

  /** Override to return dropped frames since start */
  getDroppedFrames: function () {
    return null
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.duration
  },

  /** Override to return current bitrate */
  getBitrate: function () {
    return null
  },

  /** Override to return user bandwidth throughput */
  getThroughput: function () {
    return null
  },

  /** Override to return rendition */
  getRendition: function () {
    return null
  },

  /** Override to return title */
  getTitle: function () {
    return null
  },

  /** Override to return title2 */
  getTitle2: function () {
    return null
  },

  /** Override to recurn true if live and false if VOD */
  getIsLive: function () {
    return null
  },

  /** Override to return resource URL. */
  getResource: function () {
    return this.player.currentSrc
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return "Panasonic Viera"
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return "Panasonic Viera"
  },

  /** Override to return current ad position (only ads) */
  getPosition: function () {
    return null
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player)

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, false)

    // Register listeners
    this.player.addEventListener('play', this.playListener.bind(this))
    this.player.addEventListener('pause', this.pauseListener.bind(this))
    this.player.addEventListener('playing', this.playingListener.bind(this))
    this.player.addEventListener('error', this.errorListener.bind(this))
    this.player.addEventListener('seeking', this.seekingListener.bind(this))
    this.player.addEventListener('seeked', this.seekedListener.bind(this))
    this.player.addEventListener('ended', this.endedListener.bind(this))
    this.player.addEventListener('timeupdate', this.timeupdateListener.bind(this))
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    this.player.removeEventListener('play', this.playListener)
    this.player.removeEventListener('pause', this.pauseListener)
    this.player.removeEventListener('playing', this.playingListener)
    this.player.removeEventListener('error', this.errorListener)
    this.player.removeEventListener('seeking', this.seekingListener)
    this.player.removeEventListener('seeked', this.seekedListener)
    this.player.removeEventListener('ended', this.endedListener)
    this.player.removeEventListener('timeupdate', this.timeupdateListener)
  },

  /** Listener for 'play' event. */
  playListener: function (e) {
    this.fireStart()
  },

  /** Listener for 'timeupdate' event. */
  timeupdateListener: function (e) {
    if (this.getPlayhead() > 0.1) {
      this.fireJoin()
      this.fireSeekEnd()
    }
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    this.firePause()
  },

  /** Listener for 'playing' event. */
  playingListener: function (e) {
    this.fireResume()
    this.fireBufferEnd()
    this.fireJoin()
  },

  /** Listener for 'error' event. */
  errorListener: function (e) {
    this.fireError("PLAY_FAILURE")
  },

  /** Listener for 'seeking' event. */
  seekingListener: function (e) {
    this.fireSeekBegin()
  },

  /** Listener for 'seeked' event. */
  seekedListener: function (e) {
    this.fireSeekEnd()
  },

  /** Listener for 'buffering' event. */
  bufferingListener: function (e) {
    this.fireBufferBegin()
  },

  /** Listener for 'buffered' event. */
  bufferedListener: function (e) {
    this.fireBufferEnd()
  },

  /** Listener for 'ended' event. */
  endedListener: function (e) {
    this.fireStop()
  }
})

module.exports = youbora.adapters.VieraHtml5



//////////////////
// WEBPACK FOOTER
// ./src/adapter.js
// module id = 25
// module chunks = 0